import { render, staticRenderFns } from "./pavilion_stand-order.vue?vue&type=template&id=22bafc2f&scoped=true&"
import script from "./pavilion_stand-order.vue?vue&type=script&lang=js&"
export * from "./pavilion_stand-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bafc2f",
  null
  
)

export default component.exports